import Enum from '@square/dashboard-utilities/utils/enum';
export const RequestType = new Enum(['ACCESS', 'SINGLE_DELETION', 'OBJECTION_TO_PROFILING', 'CORRECTION', 'PORTABILITY', 'RESTRICT_PROCESSING']);